import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { HttpService } from '../services/http.service';

import { RoutesRouting } from './routes.routing';
import { LoginComponent } from './login.component';
import { IndexComponent } from './index.component';
// import { ChangePasswordComponent } from './change-password.component';
import { ApiService } from '../services/api.service';
import { BuildingComponent } from './commons/building.component';

@NgModule({
  declarations: [
    LoginComponent,
    IndexComponent,
    // ChangePasswordComponent,
    BuildingComponent
  ],
  imports: [
    SharedModule,
    RoutesRouting
  ],
  providers: [
    HttpService,
    ApiService
  ]
})
export class RoutesModule { }
